import React, { useEffect, useState, createRef, useRef } from 'react';
import useStyles from './styles';

function SubpagePicker({pages, actualPageIndex, onChange}) {
  const c = useStyles();
  const [pagesState, setPagesState] = useState([]);
  const underlineRef = useRef(null);
  const containerRef = useRef(null);


  const changePage = (index, ref) => {
    if (!ref.current) {return}
    onChange(index);
  }

  const changeUnderline = (width, left, top) => {
    underlineRef.current.style.width = width + "px";
    underlineRef.current.style.left = left + "px";
    underlineRef.current.style.top = top + "px";
  }

  useEffect(() => {
    if (!pages) {return;}
    
    var newPages = pages;
    newPages.forEach((page, index) => {
      newPages[index].ref = createRef();
    });
    setPagesState(newPages);
  }, [pages])


  useEffect(() => {
    if (!pagesState || !pagesState[actualPageIndex]) {return;}
    // Set first underline
    var dimensions = pagesState[actualPageIndex].ref.current.getBoundingClientRect();
    var relativePos = {
      top: dimensions.top - containerRef.current.offsetTop,
      left:  dimensions.left - containerRef.current.offsetLeft
    }
    changeUnderline(dimensions.width, relativePos.left, (relativePos.top + 25));
  }, [pagesState])



  return (
    <div ref={containerRef} className={c.container}>
      {pagesState && pagesState.map((page, index) => {
        return <div key={"supage-picker-"+index} ref={page.ref} className={c.pageItem + (actualPageIndex === index ? " selected" : "")} onClick={() => changePage(index, page.ref)}>{page.name}</div>
      })}
      <div ref={underlineRef} className={c.underline}></div>
    </div>
  );
}

export default SubpagePicker;